import "antd/dist/reset.css";
import { Collapse, Card, Empty, Divider } from "antd";
import React from "react";
import utils from "utils";

const { Panel } = Collapse;

const DiagnosisSummaryChild = (props) => {
  return (
    <>
      {props.data?.completion_date ? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          expandIconPosition="start"
          ghost={true}
          className="mhe-list-container"
        >
          <Panel
            header={<div>{utils.FormatDate(props?.data?.completion_date, "DATE_14")}, {utils.FormatDate(props?.data?.completion_date, "TIME_1")}</div> }
            key="1"
            extra={utils.FirstNameLastName(utils.salutationPrefixName(props.data?.doctor_salutation,utils.getDisplayName(props.data?.consultation_doctor, props.data?.doctor_last_name)), "250px")}
          >
            {/* <ConversionChecklist value ={props?.data?.data} /> */}

            {props?.data?.data?.intervention_goals ? (
              Object.values(props?.data?.data?.intervention_goals).every(
                (e) => {
                  return e.length == 0;
                }
              ) ? null : (
                <>
                <Card title={"Intervention Goals"} bordered>
                  <ConversionChecklist
                    value={props?.data?.data?.intervention_goals}
                  />
                </Card>
                <Divider /></>
              )
            ) : null}
            {props?.data?.data?.evidence_based_treatment_plan ? (
              Object.values(
                props?.data?.data?.evidence_based_treatment_plan
              ).every((e) => {
                return e.length == 0;
              }) ? null : (
                <Card title="Evidence-Based Treatment Plan" bordered>
                  <ConversionChecklist
                    value={props?.data?.data?.evidence_based_treatment_plan}
                  />
                </Card>
              )
            ) : null}
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

const ConversionChecklist = React.memo((props) => {
  let output = [];
  try {
    for (const [keys, values] of Object.entries(props.value || {})) {
      if (typeof values === "object") {
        let result = checkBoxSummary(keys, values);
        output = Array.isArray(result) ? [...output, ...result] : output;
      } else {
        values
          ? output.push(keys + " : " + utils.ConvertToPascalCase(values))
          : "";
      }
    }
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0 ? (
      output.map((i, j) => {
        let split = i.split(/:(.*)/s);
        split[0] = utils.ConvertToPascalCase(split[0]);
        return (
          <React.Fragment key={j}>
            <div
              style={{
                margin: "5px 0px",
                display: "grid",
                gridTemplateColumns: "49% 2% 49%",
              }}
            >
              <div style={{ fontWeight: "500", paddingLeft: "9px" }}>
                {" "}
                {split[0]}{" "}
              </div>
              <div> : </div>
              <div>{utils.LineSplit(split[1])}</div>
            </div>
          </React.Fragment>
        );
      })
    ) : (
      <Empty description={"No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );
  }
});

const checkBoxSummary = (keys, values) => {
  let output = [];
  try {
    let { notes = "" } = values;
    for (const [key, value] of Object.entries(values)) {
      if (key == "notes") continue;
      let dataCheck = "";
      if (Array.isArray(value)) {
        for (let { is_selected, selected_value = "", service_name = "" } of value) {
          dataCheck += is_selected ? service_name ? service_name  + " | "  : selected_value + " | " : "";
        }
      } else {
        dataCheck += value ? " | " + value + " | " : " | ";
      }
      if (dataCheck)
        output.push(
          keys + " : " + dataCheck.substring(0, dataCheck.length - 2)
        );
    }
    notes ? output.push("notes : " + notes) : "";
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output;
  }
};

export default DiagnosisSummaryChild;
